<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.286"
    height="12"
    viewBox="0 0 10.286 12"
  >
    <path
      d="M9.429,4V6.571h1.894L8.391,13.429H6V16h6.857V13.429H10.963l2.931-6.857h2.391V4Z"
      transform="translate(-6 -4)"
    />
  </svg>
</template>

<script>
export default {
  name: 'ItalicIcon',
};
</script>
